import React from 'react';
import styled from 'styled-components';
import { formatInTimeZone } from 'date-fns-tz';
import { zoneLabel } from 'e-signature/helpers';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  /* A signing date is one long string whose width the author cannot predict when they place the
     box — timezone labels alone run from UTC to GMT+5:30. Let it run past the block rather than
     clip it: a truncated timestamp on a signed document is worse than an untidy one. */
  overflow: visible;
  white-space: nowrap;
  padding: 0 6px;
  &.waiting {
    background-color: #f2f2f2;
    border: 1px dashed #b5b5b5;
  }
  > div {
    font-size: ${({ fontSize = 12 }) => fontSize}px;
  }
  > div.placeholder {
    color: #707070;
    font-style: italic;
  }
`;

// The stamped value is a true instant (the moment the owner signed), so it is rendered in the
// document's timezone and carries the zone label. The main app formats the same value the same way
// for the generated PDF, so the signer and the finished document can never disagree about which
// day, hour or zone the signature landed in.
//
// `formatInTimeZone`, not `format(utcToZonedTime(...))`, and the zone label from `zoneLabel`
// rather than date-fns' `zzz` — both of those resolve the abbreviation from the already-shifted
// date and print the wrong side of a DST transition.
//
// The fallback is UTC, not the viewer's zone, to match the main app's audit page — a document
// created before `timezone` was stored must not print two different days in the same PDF.
const formatSigningDate = (value, timezone) => {
  const tz = timezone || 'UTC';
  const date = new Date(value);
  return `${formatInTimeZone(date, tz, 'MM/dd/yyyy h:mm a')} ${zoneLabel(date, tz)}`.trim();
};

export default ({ block, mode, timezone }) => {
  return (
    <Wrapper className={`mode-${mode} ${block.value ? '' : 'waiting'}`} fontSize={block.fontSize}>
      {block.value ? (
        <div>{formatSigningDate(block.value, timezone)}</div>
      ) : (
        <div className="placeholder">Auto-fills when you sign</div>
      )}
    </Wrapper>
  );
};
